<template>
    <DefaultHeader :noMargin="true"/>
    <div class="container-fluid vh-100 d-flex flex-column overflow-auto">
        <div class="row" style="height: 25vh;">
            <div class="d-flex justify-content-center align-items-center bg-light mb-4">
                <h1>Mises à jour</h1>
            </div>
        </div>
        <div class="row d-flex justify-content-center">
            <div class="row d-flex">
                <div class="col-12 col-md-2 border-end pt-5">
                    <nav>
                        <div class="p-4">
                            <h6>Versions :</h6>
                            <ul class="list-group">
                                <li v-for="(patch, index) in patchesNotes.slice().reverse()" :key="index" class="list-group-item"><a :href="'#'+patch.version">Version {{ patch.version }}</a><br>
                                    <small class="d-block text-muted"> {{ $filters.timeAgo(new Date(patch.date)) }}</small></li>
                            </ul>
                        </div>
                    </nav>
                </div>
                <div class="col-12 col-md-10 d-flex justify-content-center pt-5">
                    <div class="col-10 col-md-6 pt-3 pb-2">
                        <div v-for="(patch, index) in patchesNotes.slice().reverse()" :key="index">
                            <div :id="patch.version" class="p-2">
                                <h2>Version : {{ patch.version }} - {{ patch.title }}</h2>
                                <p>{{ patch.description }}</p>
                                <ul class="mb-5">
                                    <li v-for="(item, index) in patch.items" :key="index">
                                        <span v-if="item.text">{{ item.text }}</span>
                                        <span v-else>{{ item }}</span>
                                        <img v-if="item.image" v-bind:src="require(`../assets/` + item.image)" class="img-fluid" />
                                    </li>
                                </ul>
                                <small class="d-block mb-3 text-muted">Date : {{ new Date(patch.date).toLocaleDateString('fr-FR') }}</small>
                                <div class="my-4">
                                    <hr class="hr" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <DefaultFooter/>
    </div>

</template>

<script>
import DefaultHeader from '../components/DefaultHeader.vue'
import DefaultFooter from '../components/DefaultFooter.vue'


export default {
    components: {
        DefaultHeader,
        DefaultFooter
    },
    mounted() {
        localStorage.setItem('lastSeenPatchnote', this.patchesNotes[this.patchesNotes.length - 1].version);
    },
    data(){
        return {
            patchesNotes: [
                {
                    date: '2024-04-03',
                    title: 'Préproduction',
                    version: '0.1',
                    description: 'Améliorations et corrections de bugs mineurs : ',
                    items: [
                        'Correction de la pagination sur la liste des positions',
                        'Supression du lien vers les offres sécurité',
                        'Correction de bugs mineurs'
                    ]
                },
                {
                    date: '2024-04-17',
                    title: 'Préproduction',
                    version: '0.2',
                    description: 'Cette version comporte une nouvelle page "Mises à jour" et plusieurs améliorations de pages déjà existantes : ',
                    items: [
                        'Ajout de la page "Mises à jour"',
                        "Changement de la librairie d'icônes",
                        'Amélioration du système de pagination'
                    ]
                },
                {
                    date: '2024-05-10',
                    title: 'Préproduction',
                    version: '0.3',
                    description: 'Ajout des trajets sur la page balise : ',
                    items: [
                        'Ajout des trajets',
                        "Modifications des filtres pour l'export PDF"
                    ]
                },
                {
                    date: '2024-05-16',
                    title: 'Préproduction',
                    version: '0.5',
                    description: 'Ajout de la balise Topfly : ',
                    items: [
                        "Gestion d'un nouveau type de balise : Topfly",
                        "Gestion multi-clients",
                        "Corrections diverses"
                    ]
                },
                {
                    date: '2024-05-29',
                    title: 'Préproduction',
                    version: '0.6',
                    description: 'Améliorations générales : ',
                    items: [
                        "Amélioration de la gestion des utilisateurs",
                        "Ajout de la liste des positions pour les trajets",
                        "Ajout des dernières alertes sur la page véhicule",
                        "Nouvelle page Contact",
                        "Nouvelle page FAQ",
                        "Refonte de la page Connexion",
                        "Amélioration globale de l'interface",
                        "Corrections diverses"
                    ]
                },
                {
                    date: '2024-06-24',
                    title: 'Préproduction et gestion des alertes',
                    version: '0.7',
                    description: 'Mise à jour importante. Ajout de la gestion des alertes SMS, améliorations générales : ',
                    items: [
                        "Ajout de la gestion des alertes SMS sur la page véhicule",
                        "Nouveaux icônes de véhicules",
                        "Affichage de l'échelle sur la carte",
                        "Nouvelle adresse e-mail pour le support",
                        "Améliorations d'interface divers",
                        "Corrections diverses"
                    ]
                },
                {
                    date: '2024-06-26',
                    title: 'Patch correctif',
                    version: '0.8',
                    description: 'Cette version corrige les derniers problèmes utilisateur remontés. Elle améliore également différents interfaces.',
                    items: [
                        "Ajout d'une numérotation pour les positions d'un trajet",
                        "Affichage des positions d'un trajet dans l'ordre chronologique",
                        "Les heures s'affichent maintenant au format local de l'utilisateur plutôt qu'au format GMT (évite le décalage horaire à la visualisation depuis la France)",
                        "Correction de l'affichage de la vitesse des positions lorsque celle-ci vaut 0 km/h",
                        "Correction du changement de nom sur la page véhicule",
                        "Améliorations d'interface divers",
                        "Corrections diverses"
                    ]
                },
                {
                    date: '2024-07-02',
                    title: 'Préproduction',
                    version: '0.9',
                    description: 'Cette version active l\'envoi des SMS pour les alertes. Elle contient également plusieurs améliorations et nouvelles fonctionnalités.',
                    items: [
                        "Augmentation du zoom possible sur la carte",
                        "Ajout du suivi des véhicules",
                        "Changement du titre de la plateforme dans l'onglet du navigateur",
                        "Activation des alertes SMS",
                        "Ajout de nouvelles données pour les positions, niveaux de réception GPS et GSM",
                        "Mise à jour des icônes de véhicule",
                        "Correction du choix des icônes de véhicule",
                        "Améliorations d'interface divers",
                        "Corrections diverses"
                    ]
                },
                {
                    date: '2024-07-08',
                    title: 'Préproduction',
                    version: '0.10',
                    description: 'Cette version ajoute la possibilité de visionner les trajets passés sur la carte. Elle améliore également les informations de l\'historique des trajets et corrige des problèmes utilisateur.',
                    items: [
                        "Ajout du visionnage des trajets depuis la liste des trajets d'un véhicule",
                        "Ajoute la durée des trajets",
                        "Correction de l'affichage des alertes par véhicule",
                        "Correction des informations GPS",
                        "Correction des dates affichées dans certaines interfaces",
                        "Améliorations d'interface divers",
                        "Corrections diverses"
                    ]
                },
                {
                    date: '2024-07-11',
                    title: 'Préproduction',
                    version: '0.11',
                    description: "Cette version améliore les interfaces sur différentes pages et corrige divers problèmes d'affichage",
                    items: [
                        "Modifie la couleur des trajets affichés sur la carte",
                        "Amélioration de la navigation pour les administrateurs",
                        "Affiche l'IMEI sur la page véhicule",
                        "L'affichage des trajets sur la carte est maintenant centrée",
                        "Correction des heures affichées dans l'historique des trajets",
                        "Correction du problème des véhicules qui mettaient du temps à s'afficher sur la carte",
                        "Améliorations d'interface divers",
                        "Corrections diverses"
                    ]
                },
                {
                    date: '2024-07-16',
                    title: 'Préproduction',
                    version: '0.12',
                    description: "Cette version corrige les problèmes et améliore l'envoi de SMS. Elle améliore également plusieurs éléments de navigation.",
                    items: [
                        "Modification du logo",
                        "L'historique des trajets sur la carte est amélioré",
                        "Ajout de plusieurs données sur la page véhicule",
                        "La configuration de SMS est maintenant réservée aux admin",
                        "Modification des noms de rôles utilisateur",
                        "Correction du zoom minimum sur la carte",
                        "Correction de l'envoi des SMS",
                        "Améliorations d'interface divers",
                        "Corrections diverses"
                    ]
                },
                {
                    date: '2024-07-24',
                    title: 'Avant lancement V1',
                    version: '0.13',
                    description: "Cette version corrige les derniers retours utilisateurs avant la V1.",
                    items: [
                        "Modification du logo",
                        "Ajoute un panneau de navigation dans l'historique des trajets",
                        "Améliore l'ergonomie de la carte pour les clients n'ayant qu'un seul véhicule",
                        "L'heure des alertes SMS est maintenant sur le créneau français",
                        "Ajoute des données à l'affichage sur les véhicules",
                        "Ajoute l'IMEI aux rapportds PDF",
                        "Correction du mode suivi d'un véhicule sur la carte",
                        "Correction du niveau de batterie affiché pour les alertes",
                        "Améliorations d'interface divers",
                        "Corrections diverses"
                    ]
                },
                {
                    date: '2024-07-30',
                    title: 'Lancement V1',
                    version: '1.0',
                    description: "V1 ouverte aux clients. Amélioration globale de la plateforme.",
                    items: [
                        "Les alertes sont maintenant visibles dans les listes de positions",
                        "Ajout de liens vers Google map",
                        "Modification de l'affichage sur la page véhicule",
                        "Correction de la page véhicule en navigation mobile",
                        "Améliorations d'interface divers",
                        "Corrections diverses"
                    ]
                },
                {
                    date: '2024-08-02',
                    title: 'Gestion des données',
                    version: '1.1',
                    description: "Ajout de nouvelles données et multiples petites corrections.",
                    items: [
                        "Amélioration de l'interface d'export de rapport PDF",
                        "Ajoute la température aux données des positions",
                        "Ajout de la plaque d'immatriculation pour les véhicules",
                        "Les liens des trajets de la page véhicule sont maintenant cliquables",
                        "Améliorations d'interface divers",
                        "Correction de l'affichage des alertes dans la liste des trajets",
                        "Corrections diverses"
                    ]
                },
                {
                    date: '2024-08-06',
                    title: 'Graphes de contrôle',
                    version: '1.2',
                    description: "Ajout des graphes de contrôle en prévision du futur dashboard.",
                    items: [
                        "Ajout du graphe de températures pour les trajets (page trajet)",
                        "Ajout du graphe de vitesses pour les trajets (page trajet)",
                        "Améliorations d'interface divers",
                        "Corrections diverses"
                    ]
                },
                {
                    date: '2024-09-16',
                    title: 'Nouvelles fonctionnalités',
                    version: '1.3',
                    description: "Ajout de la recherche par véhicule et corrections diverses.",
                    items: [
                        "Ajout de la recherche de véhiucles (nom ou immatriculation) sur la page liste des véhicules",
                        "Le nom du groupe s'affiche maintenant sous le nom du véhicule",
                        "Amélioration de l'affichage pour les informations manquantes",
                        "Gestion de nouveaux systèmes de géolocalisation",
                        "Les rapports PDF n'affichent maintenant qu'en page 1 le titre du rapport",
                        "Améliorations d'interface divers",
                        "Correction empêche l'ajout de groupe sans nom",
                        "Correction du filtre de dates pour l'affichage des positions",
                        "Corrections diverses"
                    ]
                },
                {
                    date: '2024-09-20',
                    title: 'Refonte de la barre de navigation',
                    version: '1.4',
                    description: "Refonte de la barre de navigation dans le header",
                    items: [
                        "Ajout des notifications",
                        { text: "Refonte visuelle des liens de navigation", image: "navbar-change.png" }
                    ]
                },
                {
                    date: '2024-09-21',
                    title: 'Amélioration de la carte',
                    version: '1.5',
                    description: "Ajoute la possibilité de contrôler les alertes textos depuis la carte.",
                    items: [
                        "Il est maintenant possible d'activer et désactiver les alertes textos des véhicules depuis la carte",
                        "L'utilisateur est maintenant redirigé sur la page demandée après la connexion",
                        "Amélioration de la sécurité"
                    ]
                },
                {
                    date: '2024-09-28',
                    title: "Amélioration de l'interface",
                    version: '1.6',
                    description: "Amélioration globale de l'interface de navigation.",
                    items: [
                        "Affichage des adresses de départ et d'arrivée des trajets sur la page véhicule",
                        "Affichage de la dernière température reçue sur les écrans des véhicules",
                        "Modification de la navigation, les visiteurs ne peuvent plus modifier les informations des véhicules",
                        "Modification de la navigation pour les opérateurs",
                        "Correction et amélioration du menu en version mobile"
                    ]
                },
                {
                    date: '2024-10-08',
                    title: "Mise à jour des alertes",
                    version: '1.7',
                    description: "Amélioration du nombre d'alertes gérées.",
                    items: [
                        "Gestion de nouvelles alertes, notamment sur la conduite brutale",
                        "Affichage des alertes sur la carte de visualisation des trajets",
                        "Ajout de la télésurveillance en lien avec les centres de télésurveillance",
                        "Ajout de la gestion de visibilité pour les groupes",
                        "Amélioration de la modification des groupes",
                        "Mise à jour de sécurité"
                    ]
                },
                {
                    date: '2024-10-08',
                    title: "Mise à jour d'interface",
                    version: '1.8',
                    description: "Amélioration et corrections des interfaces sur plusieurs pages.",
                    items: [
                        "Suppression de la colonne Groupe dans l'affichage des véhicules",
                        "Nouveaux icônes pour les alertes sur l'historique des trajets",
                        "Améliorations globales de l'interface",
                        "Correction de la sélection des dates sur mobile",
                        "Correction de l'affichage des véhicules sans icône"
                    ]
                },
                {
                    date: '2024-10-21',
                    title: "Refonte des trajets et envois de commandes",
                    version: '1.9',
                    description: "Refonte de l'affichage et de la navigation dans les trajets et gestion des envois de commandes aux véhicules pour SMS",
                    items: [
                        "Modification de l'affichage des trajets sur la carte",
                        "Affichage du panneau de contrôle par défaut ouvert sur les historiques de trajets",
                        "Ajout de liens entre les différentes pages de trajets",
                        "Amélioration de la page listant les positions des trajets",
                        "Ajout de panneau de contrôle sur la carte des véhicules",
                        "Ajout de l'envoi de commandes aux véhicules",
                        "Améliorations globales de l'interface",
                        "Corrections diverses"
                    ]
                },
                {
                    date: '2024-10-23',
                    title: "Amélioration du patch précédent",
                    version: '1.10',
                    description: "Amélioration du panneau de contrôle de la carte et de l'envoi de commandes",
                    items: [
                        "Ajout de nouvelles information dans le panneau de contrôle de la carte",
                        "Correction de l'ouverture / fermeture du panneau de contrôle de la carte",
                        "Correction de l'affichage des commandes sauvegardées pour un grand nombre de commandes",
                        "Corrections diverses"
                    ]
                },
                {
                    date: '2024-10-24',
                    title: "Améliorations de navigation",
                    version: '1.11',
                    description: "Amélioration du panneau de contrôle des historiques et de l'envoi de commandes",
                    items: [
                        "Ajout d'information et mise à jour du panneau de contrôle dans la visualisation des trajets",
                        "Ajout du login d'utilisateur dans les commandes envoyées",
                        "Corrections diverses"
                    ]
                },
                {
                    date: '2024-11-08',
                    title: "Ajout des informations d'état des véhicules",
                    version: '1.12',
                    description: "Gestion des entrées de balises pour connaître les états des véhicules, améliorations générales des fonctionnalités déjà présentes",
                    items: [
                        "Les véhicules n'ayant pas émis de données depuis plus de 24h sont maintenant surlignés en rouge dans la liste des véhicules",
                        "Ajout de la date de dernière connexion pour les utilisateurs, visible sur la page de gestion des utilisateurs",
                        "Amélioration de la FAQ",
                        "Ajout d'une page de gestion de tous les véhicules destinée aux agents SMS",
                        "Corrections diverses"
                    ]
                },
                {
                    date: '2024-11-21',
                    title: "Amélioration des informations de véhicules",
                    version: '1.13',
                    description: "Gestion de l'intégralité des entrées de balises pour connaître les états des véhicules",
                    items: [
                        "Ajout de la page configuration des balises pour les supers admins",
                        "Affichage des états des véhicules sur la page véhicule",
                        "Modification de l'affichage des modèles de balises",
                        "Corrections de textes dans l'interface",
                        "Correction d'une erreur d'affichage pour les trajets n'ayant pas de coordonnées",
                        "Corrections mineures"
                    ]
                },
                {
                    date: '2024-12-02',
                    title: "Ajout d'icônes",
                    version: '1.14',
                    description: "Ajout d'icônes pour les motos",
                    items: [
                        "Ajout de nouveaux icônes"
                    ]
                },
                {
                    date: '2024-12-04',
                    title: "Amélioration d'interface",
                    version: '1.15',
                    description: "Amélioration générale de l'interface sur plusieurs pages d'Argos",
                    items: [
                        "Affichage de l'offre commerciale dans la page véhicule",
                        "Affichage en temps réel des informations dans le panneau de contrôle de la carte",
                        "Le lien sur le nom du véhicule depuis la page véhicule mène directement sur la carte",
                        "Modification des icônes motos et scooter"
                    ]
                },
                {
                    date: '2024-12-04',
                    title: "Correction de la version précédente",
                    version: '1.15.1',
                    description: "Correction de la dernière mise à jour",
                    items: [
                        "Correction du rafraîchissement du panneau de la carte en mode suivi de véhicule"
                    ]
                },
                {
                    date: '2024-12-09',
                    title: "Ajout de la facturation",
                    version: '1.16',
                    description: "Version introduisant la fonctionnalité facturation pour le personnel de SMS, accompagné de corrections mineures",
                    items: [
                        "Ajout de l'interface facturation pour le personnel SMS",
                        "Les noms des véhicules ont maintenant un fond pour les rendre plus lisibles depuis la carte",
                        "Correction de la visibilité des groupes",
                        "Corrections et améliorations mineures"
                    ]
                },
                {
                    date: '2024-12-13',
                    title: "Ajout du geocoding Europe",
                    version: '1.17',
                    description: "La version améliore la résolution d'adresses et ajoute les pays de l'Europe. Elle inclue également quelques correctifs divers.",
                    items: [
                        "Ajout du geocoding pour l'Europe",
                        "Change l'affichage de l'IMEI des balises",
                        "Correction du geocoding français en cas de défaut du service"
                    ]
                },
                {
                    date: '2024-12-27',
                    title: "Amélioration de l'affichage",
                    version: '1.18',
                    description: "Amélioration de l'affichage pour les données des véhicules",
                    items: [
                        "Change l'affichage de l'IMEI des balises",
                        "Affiche l'IMEI dans la liste des véhicules",
                        "Correction dans le cas où les dernières coordonnées ne sont pas connues"
                    ]
                },
                {
                    date: '2025-02-22',
                    title: "Patch majeur",
                    version: '2.0',
                    description: "Nouvelles fonctionnalités et modifications d'interfaces diverses",
                    items: [
                        "Gestion des badge et coupure démarreur",
                        "Amélioration de la fluidité",
                        "Amélioration des interfaces"
                    ]
                },
                {
                    date: '2025-02-25',
                    title: "Amélioration de la carte",
                    version: '2.1',
                    description: "Ajout du moteur de recherche sur la carte",
                    items: [
                        "Moteur de recherche sur la carte principale pour trouver les véhicules",
                        "Modification de l'affichage des groupes"
                    ]
                },
                {
                    date: '2025-02-26',
                    title: "Page détail de badge",
                    version: '2.2',
                    description: "Ajout de la page détaillant l'activité d'un badge, accessible depuis la liste des badges",
                    items: [
                        "Page de badge contenant les informations et l'activité récente, version de test",
                    ]
                },
                {
                    date: '2025-02-27',
                    title: "Patch mineur",
                    version: '2.3',
                    description: "Améliorations diverses, fonctionnalités et interfaces",
                    items: [
                        "Ajout de détails sur la page badge",
                        "Changement de position des éléments de contrôle sur la carte"
                    ]
                },
                {
                    date: '2025-03-03',
                    title: "Ajout de fonctions sécurités",
                    version: '2.4',
                    description: "Ajout des fonctions de sécurités réservée pour le moment aux administrateurs SMS. Le patch contient également des réglages graphiques pour l'ensemble des utilisateurs.",
                    items: [
                        "Ajout des menus Corridoring et Missions pour les administrateurs SMS",
                        "Uniformisation des champs de recherche",
                        "L'icône pour contrôler l'affichage des groupes sur la carte est maintenant en haut à droite",
                        "Les coordonnées GPS sont maintenant affichées avec une précision à 1 mètre",
                        "Le lien sur la page des badges est plus visible",
                        "Uniformisation visuelle des boutons"
                    ]
                },
                {
                    date: '2025-03-04',
                    title: "Mise à jour des fonctions sécurité",
                    version: '2.5',
                    description: "Modification des corridorings",
                    items: [
                        "Ajout de la possibilité de créer un corridoring à partir d'un trajet choisi",
                        "Correction visuelle de l'ombre à l'affichage des popins"
                    ]
                },
                {
                    date: '2025-03-05',
                    title: "Mise à jour des fonctions sécurité",
                    version: '2.6',
                    description: "Modification des corridorings",
                    items: [
                        "Moteur de recherche et affichage des corridorings sur la carte",
                        "Modification de l'affichage des corridorings et missions",
                        "Correction de l'icône de contrôle d'affichage sur la carte"
                    ]
                },
                {
                    date: '2025-03-10',
                    title: "Modifications et corrections d'affichages",
                    version: '2.7',
                    description: "Modification de l'affichage des débuts et fins de trajets sur la carte",
                    items: [
                        "Mise à jour des corridorings",
                        "Le début et la fin des corridorings et missions sont maintenant affichés",
                        "Correction d'un bug lors du changement d'icône depuis la page véhicule"
                    ]
                },
                {
                    date: '2025-03-12',
                    title: "Mise à jour des missions et corridorings",
                    version: '2.8',
                    description: "Mise à jour modifiant les missions et corridorings",
                    items: [
                        "Modification de l'affichage des missions",
                        "Modification de la page informations d'une mission",
                        "L'affichage des alertes de mission en rouge est maintenant dynamique"
                    ]
                },
                {
                    date: '2025-03-12',
                    title: "Mise à jour de l'interface",
                    version: '2.9',
                    description: "Mise à jour et correction de divers détails dans les interfaces",
                    items: [
                        "Suppression du pictogramme Info dans la page de gestion des groupes",
                        "Correction du libellé du rôle utilisateur dans l'un des select de la page utilisateurs"
                    ]
                },
                {
                    date: '2025-03-20',
                    title: "Amélioration de la version mobile",
                    version: '2.10',
                    description: "Modification des affichages en version mobile et corrections",
                    items: [
                        "Modification de l'affichage de la page trajet sur mobile",
                        "Modification de l'affichage de la page véhicule sur mobile",
                        "Modification de l'affichage général des véhicules",
                        "Modification des affichages pour les données manquantes",
                        "Correction d'un problème d'affichage du menu avec la barre de recherche"
                    ]
                },
                {
                    date: '2025-04-02',
                    title: "Modification des alertes et PWA",
                    version: '2.11',
                    description: "Améliorations générales, nouvelle gestion d'alertes et Progressive Web App",
                    items: [
                        "Ajout de l'alarme bouton SOS pour les balises qui en disposent",
                        "Modification de l'affichage des icônes pour les débuts et fins de trajets",
                        "Modification de l'affichage des alertes",
                        "Augmente le nombre de position dans l'historique des trajets",
                        "Ajout de nouveaux icônes pour les véhicules",
                        "Ajout d'une version progressive web app"
                    ]
                },
                {
                    date: '2025-04-13',
                    title: "Modification des alertes et PWA",
                    version: '2.12',
                    description: "Améliorations générales, nouvelle gestion d'alertes et Progressive Web App",
                    items: [
                        "Ajout du numéro de version sur la page de connexion et dans le footer",
                        "Amélioration du cache de la version installable",
                        "Correction d'un problème de fichier sur la version mobile"
                    ]
                },
                {
                    date: '2025-04-18',
                    title: "Mise à jour technique",
                    version: '2.13',
                    description: "Correctif technique pour mobiles",
                    items: [
                        "Modification du port pour les connexions en HTTPS"
                    ]
                },
                {
                    date: '2025-04-29',
                    title: "Historique à la journée (Beta)",
                    version: '2.14',
                    description: "Possibilité de visualiser l'historique d'un véhicule sur une journée",
                    items: [
                        "Version Beta : sur la page véhicule il est maintenant possible d'afficher l'historique des mouvements d'un véhicule sur une journée",
                        "Correctif : nom de certaines alarmes dans la liste des positions"
                    ]
                },
                {
                    date: '2025-05-16',
                    title: "Ajout de module d'aministration",
                    version: '2.15',
                    description: "Modules destinés au personnel SMS",
                    items: [
                        "Gestion des clients",
                        "Amélioration de la gestion des balises"
                    ]
                },
                {
                    date: '2025-05-19',
                    title: "Ajout d'informations sur les véhicules",
                    version: '2.16',
                    description: "Amélioration des informations affichées pour les évènements",
                    items: [
                        "De nouveaux évènements sont disponibles dans la liste des évènements de véhicules",
                        "Ajout de l'information de contact véhicule, permet de savoir si le contact du véhicule est allumé ou éteint (pour les véhicules pouvant le gérer)"
                    ]
                },
                {
                    date: '2025-05-20',
                    title: "Ajout de la gestion des contacts d'alarmes",
                    version: '2.17',
                    description: "Permet de gérer les contacts d'alerte pour les véhicules, e-mail et textos",
                    items: [
                        "Ajout de la gestion des contacts dans le menu des administrateurs",
                        "Ajout de la gestion des contacts pour les alarmes sur la page véhicule",
                    ]
                },
                {
                    date: '2025-05-21',
                    title: "Amélioration de l'affichage",
                    version: '2.18',
                    description: "Améliore différentes fonctionnalités de l'affichage",
                    items: [
                        "Modification de l'affichage des noms pour les alertes personnalisées",
                        "Il n'est maintenant plus possible de choisir des dates dans le futurs pour les trajets à la journée (page véhicule)",
                        "Le contact s'affiche maintenant à côté du nom dans le contrôle des alertes (page véhicule)"
                    ]
                },
                {
                    date: '2025-05-27',
                    title: "Ajout du stationnement surveillé",
                    version: '2.19',
                    description: "Ajout de la fonctionnalité de stationnement surveillé pour les véhicules ayant l'offre GeoPlus ou supérieure, contient également quelques mises à jours d'affichage.",
                    items: [
                        "Le véhicules ayant l'offre GeoPlus ou supérieure peuvent maintenant activer le stationnement surveillé",
                        "Ajout de nouveaux icônes pour les véhicules",
                    ]
                },
                {
                    date: '2025-05-28',
                    title: "Clarifications d'interfaces",
                    version: '2.20',
                    description: "Améliore les interfaces pour clarifier les informations affichées",
                    items: [
                        "Ajout du logo Argos sur la page de connexion",
                        "Amélioration des informations véhicule sur la carte",
                        "Clarification des alertes comprises en fonction du type de balise installée",
                        "Changements de textes dans plusieurs interfaces",
                    ]
                },
                {
                    date: '2025-07-22',
                    title: "Nouvelles infos véhicules",
                    version: '2.21',
                    description: "Ajoute de nouvelles informations pour les véhicules",
                    items: [
                        "Ajout de la couleur, marque, modèle du véhicule",
                        "Modifications de l'affichage des informations des véhicules",
                    ]
                },
                {
                    date: '2025-07-24',
                    title: "Correction affichage",
                    version: '2.22',
                    description: "Corrections mineures d'affichage",
                    items: [
                        "Corrige l'affichage de l'IMEI des PTI",
                        "Ajoute un nouvel icône pour les véhicules",
                    ]
                },
                {
                    date: '2025-07-25',
                    title: "Modification des missions",
                    version: '2.23',
                    description: "Changements mineurs des missions",
                    items: [
                        "Ajout du bouton de contrôle de fin",
                        "Modifications de l'affichage",
                    ]
                },
                {
                    date: '2025-07-25',
                    title: "Modification des informations de véhicules",
                    version: '2.24',
                    description: "Gestion des informations de véhicules",
                    items: [
                        "L'IMEI n'est plus affiché systématiquement avec l'icône du véhicule",
                        "Amélioration de l'affichage",
                        "Il est maintenant possible de modifier les informations de véhicules depuis la page véhicule",
                    ]
                },
                {
                    date: '2025-07-30',
                    title: "Modification des missions",
                    version: '2.25',
                    description: "Changement de la gestion des missions. Ajout des nouveaux critères de sécurité.",
                    items: [
                        "Ajout des chauffeurs de missions, la liste est accessible depuis le menu sécurité. Les missions peuvent intégrer des chauffeurs.",
                        "Modification des droits d'accès aux missions",
                        "Ajout de l'alarme : perte de verticalité",
                        "Ajout de nouveaux icônes pour les véhicules",
                        "Modification de l'ordre d'affichage des véhicules, maintenant par ordre alphabétique",
                        "Modifications d'affichage mineures"
                    ]
                },
                {
                    date: '2025-07-31',
                    title: "Corrections missions",
                    version: '2.26',
                    description: "Ensemble de corrections et modifications mineures",
                    items: [
                        "Ajout d'icône pour les voitures Kangoo",
                        "Affichage d'un message par défaut lorsqu'il n'y a pas d'historique de mission",
                        "Correction des icônes début et fin pour les corridorings"
                    ]
                },
                {
                    date: '2025-08-25',
                    title: "Mise à jour missions et rapports",
                    version: '2.27',
                    description: "Mise à jours du fonctionnement des missions et des rapports PDF",
                    items: [
                        "Les rapports PDF des trajets sont téléchargeables depuis la page trajets",
                        "Modifications d'affichage pour les missions",
                        "Les missions contiennent maintenant des commentaires de début et fin",
                        "Ajout des tests d'avant lancement de mission",
                        "Ajout d'un lien vers la visualisation de la mission sur la carte depuis la page mission",
                        "Ajout de la gestion des véhicules prenant part à la mission mais non gérés par Argos",
                        "Il est maintenant possible d'ajouter des groupes de véhicules aux missions",
                        "Ajout des commentaires sur les missions",
                        "Envoi de rapports automatiques à la fin des missions",
                        "L'historique des missions est maintenant ordonné dans l'ordre chronologique par date de fin",
                        "Ajout des logs de modification des missions",
                        "Correction : la pagination des trajets pour la création de corridoring fonctionne correctement",
                        "Correction : il n'est plus possible de cliquer sur l'icône des véhicules dans la création de corridoring"
                    ]
                },
                {
                    date: '2025-09-09',
                    title: "Mise à jour missions",
                    version: '2.28',
                    description: "Mise à jours du fonctionnement des missions",
                    items: [
                        "Les corridorings n'enregistrent plus qu'une alarme de sortie et de retour en corridoring",
                        "Affichage de l'ID de mission sur toutes les pages de missions",
                        "Ajout du bouton télécharger les rapports sur les missions terminées",
                        "Les offfres d'alertes SMS et mails non disponibles sont maintenant grisées",
                        "Correction : les trajets avec un grand nombre de positions s'affichent correctement",
                        "Correction : les commentaires de missions se rafraichissent correctement",
                        "Correction : lors du changement de gestion client (opérateurs) sur les pages de création de mission, l'utilisateur est redirigé sur la page de listing des missions"
                    ]
                },
                {
                    date: '2025-09-14',
                    title: "Mise à jour missions",
                    version: '2.29',
                    description: "Amélioration des missions",
                    items: [
                        "Ajout de la documentation et documentation contextuelle pour les opérateurs",
                        "Ajout de l'affichage d'IMEI pour les admins",
                        "Correction des rapports PDF",
                    ]
                },
                {
                    date: '2025-09-18',
                    title: "Mise à jour missions",
                    version: '2.30',
                    description: "Amélioration des missions",
                    items: [
                        "Ajout d'un bouton pour annuler les missions en cours",
                        "Ajout des noms pour les nouveaux matériels",
                        "Modification de l'affichage des retours en corridoring sur la carte",
                        "Ajout de redirections pour les opérateurs lors du changement de client",
                        "Correction d'une faute d'orthographe (annulé = annulée)",
                    ]
                },
                {
                    date: '2025-09-20',
                    title: "Mise à jour missions",
                    version: '2.31',
                    description: "Amélioration des missions",
                    items: [
                        "Ajout du bouton annuler les missions pour les opérateurs",
                        "Il est maintenant possible pour les opérateurs de modifier certains éléments d'une mission même après son départ",
                        "Correction de la distance du corridoring affichée sur la page mission",
                        "Correction de la distance de la mission dans l'historique"
                    ]
                },
                {
                    date: '2025-09-29',
                    title: "Modifications d'interfaces",
                    version: '2.32',
                    description: "Modifications des menus pour les opérateurs",
                    items: [
                        "Les opérateurs ont maintenant une vue globale des véhicules, tous clients confondus",
                        "Après connexion, les opérateurs et admins sont redirigés vers la liste des véhicules",
                        "Après connexion, la redirection est par défaut vers la page à laquelle on souhaitait accéder",
                    ]
                },
                {
                    date: '2025-10-10',
                    title: "Modifications d'interfaces",
                    version: '2.33',
                    description: "Modifications diverses des interfaces",
                    items: [
                        "Nouveaux icônes de véhicules",
                        "Après connexion, les opérateurs et admins sont redirigés vers la liste des véhicules",
                        "Certains affichages d'alarmes ont été améliorés",
                        "L'affichage des véhicules avec lien ne se surligne plus au passage de la souris",
                        "Ajout de messages par défaut lorsqu'aucun corridoring n'est disponible",
                        "Mise à jour de l'affichage des missions"
                    ]
                },
                {
                    date: '2025-10-22',
                    title: "Gestion pour les super administrateurs",
                    version: '2.34',
                    description: "Gestion poussée des balises pour les super administrateurs",
                    items: [
                        "Possibilité d'ajouter des balises en direct",
                        "Modification des données avancées des balises",
                        "Ajout de nouveaux icônes de véhicules",
                        "Modification de l'affichage pour les balises non facturables"
                    ]
                },
                {
                    date: '2025-10-28',
                    title: "Modifications d'interfaces",
                    version: '2.35',
                    description: "Mise à jour de la carte et d'interfaces diverses",
                    items: [
                        "Modification du menu de sélection des clients pour éviter d'agrandir l'écran",
                        "Modification de la gestion des paramètres sur la carte",
                        "Ajout de la possibilité de voir les zones de détection sur les cartes de corridorings",
                        "Correction : la date de mise en service affichée sur la page véhicule est maintenant celle de la mise en service client",
                    ]
                },
                {
                    date: '2025-11-07',
                    title: "Modifications de la carte",
                    version: '2.36',
                    description: "Mise à jour de la carte et d'interfaces diverses",
                    items: [
                        "Amélioration de toutes les interfaces de cartes (historique de trajets, corridoring, carte principale, missions et historiques de missions)",
                        "Il est maintenant possible de modifier les rayons des positions de geofencing depuis la carte des geofencings",
                        "Correction d'affichage de la carte en version mobile",
                    ]
                },
                {
                    date: '2025-11-13',
                    title: "Geofencings",
                    version: '2.37',
                    description: "Ajout des interfaces de gestion des geofencings",
                    items: [
                        "Ajout de la carte permettant de visualiser tous les geofencings",
                        "Possibilité de créer, modifier et supprimer des geofencings",
                        "Possibilité d'assigner des geofencings aux véhicules",
                    ]
                },
                {
                    date: '2025-11-15',
                    title: "Amélioration des cartes",
                    version: '2.38',
                    description: "Permet l'affichage des geofencings sur d'autres cartes",
                    items: [
                        "Il est maintenant possible de visualiser les geofencings sur la carte principale et sur l'historique des trajets",
                        "Le zoom n'est plus modifié lors du rafraîchissement de la carte principale",
                        "Amélioration de la page facturation pour les admins",
                    ]
                },
                {
                    date: '2025-11-28',
                    title: "Améliorations générales",
                    version: '2.39',
                    description: "Affichage de nouvelles données",
                    items: [
                        "Les geofencings et les corridorings actifs s'affichent sur la carte à la sélection d'un véhicule",
                        "La page de facturation admin permet maintenant d'afficher le détail des véhicules",
                        "La liste des positions d'un véhicule affiche maintenant l'état de la sortie 1 (DOut 1)",
                    ]
                },
                {
                    date: '2025-12-05',
                    title: "Correction de la carte",
                    version: '2.40',
                    description: "Correction de la carte",
                    items: [
                        "Corrige l'affichage d'un véhicule sur la carte suite à une recherche",
                    ]
                },
                {
                    date: '2025-12-19',
                    title: "Gestion des envois de commandes pour les administrateurs",
                    version: '2.41',
                    description: "Ajout de la fonctionnalité de création de bouton pour l'envoi de commandes et améliorations diverses",
                    items: [
                        "Les administrateurs peuvent maintenant créer des boutons d'envoi de commandes pour les véhicules",
                        "Amélioration de la création des corridorings, les points sont maintenant mieux espacés permettant une meilleure sécurité",
                        "Pour les administrateurs Argos, les commandes aux balises sont maintenant spécifiques au type de balise"
                    ]
                },
                {
                    date: '2025-12-30',
                    title: "Gestion surveillance parking automatique (badges)",
                    version: '2.42',
                    description: "Ajout des changement de status (ON/OFF) pour la surveillance de parking automatique dans les alarmes",
                    items: [
                        "Les changment de surveillance (ON/OFF) produisent maintenant des alarmes info",
                        "Ajout d'un nouvel icône pour les alarmes"
                    ]
                },
                {
                    date: '2026-01-16',
                    title: "Mises à jour mineures",
                    version: '2.43',
                    description: "Petites modifications et correctifs mineurs",
                    items: [
                        "Correction du panneau d'envoi des commandes pour les administrateurs SMS",
                        "Ajout d'un écran de contrôle des messages balises pour les administrateurs SMS",
                        "Corrections mineures diverses"
                    ]
                },
                {
                    date: '2026-02-12',
                    title: "Mises à jour mineures",
                    version: '2.44',
                    description: "Recherche d'adresse",
                    items: [
                        "Ajout de la recherche par adresse dans les positions",
                        "Ajout de la recherche d'adresse sur toutes les cartes",
                        "Corrections mineures diverses"
                    ]
                },
                {
                    date: '2026-02-19',
                    title: "Gestion de corridorings",
                    version: '2.45',
                    description: "Améliore la création de corridorings",
                    items: [
                        "Possibilité de créer un corridoring à partir d'un trajet choisi sur la carte",
                        "Possibilité de créer un corridoring à partir d'invervals de temps",
                    ]
                },
                {
                    date: '2026-02-20',
                    title: "Amélioration du lancement des missions",
                    version: '2.46',
                    description: "Automatisation des tests au lancement de la mission",
                    items: [
                        "Les tests d'avant lancement de missions sont maintenant automatisés pour les opérateurs de télésurveillance SMS",
                        "Moteur de recherche pour les missions en attente dans le panneau de contrôle des missions",
                        "Modification de l'affichage des missions, moins d'informations pour les véhicules et ajout du chauffeur",
                    ]
                },
                {
                    date: '2026-02-26',
                    title: "Rapports Excel",
                    version: '2.47',
                    description: "Ajout des rapports Excel et améliorations diverses",
                    items: [
                        "Ajout des rapports Excel pour les trajets",
                        "Ajout des évènements début et fin de mission pour chaque véhicule",
                    ]
                },
                {
                    date: '2026-03-05',
                    title: "Amélioration de la carte",
                    version: '2.48',
                    description: "Amélioration de l'affichage sur la carte",
                    items: [
                        "La carte contient maintenant le nom des routes (nationales, autoroutes..) ainsi que beaucoup plus de détails",
                        "Les itinéraires alternatifs des corridorings s'affichent maintenant sur la carte",
                    ]
                },
                {
                    date: '2026-03-12',
                    title: "Correctifs mineurs",
                    version: '2.49',
                    description: "Corrections diverses mineures sur les pages du site",
                    items: [
                        "La pagination dans l'historique des missions fonctionne maintenant correctement et charge le nombre de missions demandées",
                        "Correction de l'affichage des corridorings avec itinéraires alternatifs, les branches des trajets sont maintenant reliées à l'itinéraire principal",
                        "Pour les utilisateurs non opérateurs : les filtres de groupes sur les pages des véhicules et de la cartes sont maintenant sauvegardés entre les navigations",
                        "Ajoute la possibilité d'ordonner les véhicules en glisser/déposer depuis la liste des véhicules"
                    ]
                },
                {
                    date: '2026-03-13',
                    title: "Correctif menu",
                    version: '2.50',
                    description: "Correction à destination des opérateurs de SMS",
                    items: [
                        "La sélection du client affiché depuis le menu a été modifiée pour s'afficher correctement dans toutes les conditions",
                        "Amélioration du menu en version mobile"
                    ]
                },
                {
                    date: '2026-03-18',
                    title: "Mise à jour fonction mission",
                    version: '2.51',
                    description: "Mise à jour des fonctionnalités de mission, sur la carte et dans les interfaces",
                    items: [
                        "Il est maintenant possible d'afficher les corridorings sur les cartes d'historiques de missions",
                        "Amélioration de l'affichage des historiques de missions",
                        "Amélioration de l'affichage de l'écran de contrôle des missions en cours",
                        "Les missions en attente sont maintenant organisée par horaires",
                        "Refonte visuelle du panneau latéral gauche dans les cartes"
                    ]
                },
                {
                    date: '2026-03-18',
                    title: "Corrections de bugs mineurs",
                    version: '2.52',
                    description: "Corrections de bugs mineurs dans divers endroits de l'interface",
                    items: [
                        "Rechercher des véhicules depuis la carte ne provoque plus la modification du filtres des groupes",
                        "Pour les opérateurs SMS : arrêter le mode suivi sur la carte ne renvoit plus à la page des balises",
                    ]
                },
                {
                    date: '2026-03-31',
                    title: "Améliorations diverses",
                    version: '2.53',
                    description: "Améliorations d'interface et de clarté à divers endroits",
                    items: [
                        "Modification de textes pour améliorer la compréhension",
                        "Correction du menu en version mobile, cliquer sur la section courante ferme maintenant le menu",
                        "Amélioration du filtrage des groupes sur la page véhicules, clarification du fonctionnement",
                        "Correction des adresses de début et fin de trajet pour les nouveaux modèles de balises",
                        "Correction interface opérateurs : le changement de client ne laisse plus l'écran grisé",
                        "Ajout de l'horaire pour les missions",
                        "Ajout du scheduler pour le passage automatique en mode surveillance parking selon les horaires définis",
                        "Ajout de nouveaux icônes",
                        "Amélioration de la page véhicule, affichage revu et informations supplémentaires"
                    ]
                },
                {
                    date: '2026-04-10',
                    title: "Améliorations d'interface",
                    version: '2.54',
                    description: "Meilleur affichage des évènements",
                    items: [
                        "Les icônes et couleurs des évènements sont modifiées pour mieux faire ressortir les alarmes",
                        "Amélioration de l'affichage véhicule sur la carte",
                        "Ajout des commandes à distance pour les opérateurs SMS"
                    ]
                },
                {
                    date: '2026-04-14',
                    title: "Commandes mission",
                    version: '2.55',
                    description: "Ajout des commandes de mission et amélioration de l'interface",
                    items: [
                        "Ajout pour les opérateurs SMS des commandes de sécurisation et gestion carjaking depuis la carte",
                        "L'affichage véhicule est plus compact et contient maintenant tous les états associés de la balise",
                        "Ajout des nouveaux noms de balises",
                        "Ajout de nouveaux icônes"
                    ]
                },
                {
                    date: '2026-04-16',
                    title: "Améliorations diverses",
                    version: '2.56',
                    description: "Améliorations d'interface, des rapport, des missions",
                    items: [
                        "Les rapports de mission affichent les infos d'une façon différenciée des alarmes",
                        "Ajout des entrées sorties sur la carte (dans le détail des véhicules). Uniquement pour les véhicules concernés",
                        "Ajout d'un affichage alternatif dans la liste des véhicules, modifiable en haut à droite de l'écran",
                        "Modification de l'affichage des états de balises, changement de l'importance dans l'affichage selon la priorité des informations",
                        "Correction : dans la création de mission, la liste des véhicules s'affiche correctement même lorsqu'il y en a beaucoup",
                        "Correction : dans la création de mission, la liste des chauffeurs s'affiche correctement même lorsqu'il y en a beaucoup",
                    ]
                },
                {
                    date: '2026-04-28',
                    title: "Mise à jour de l'affichage grille",
                    version: '2.57',
                    description: "Amélioration de l'affichage des véhicules en mode grille en vue d'en faire la vue par défaut",
                    items: [
                        "En mode grille, ajout des liens vers la carte (suivi de véhicule), vers la fiche et l'historique des évènements du véhicule",
                        "Les missions peuvent maintenant être lancées sans corridoring",
                        "Amélioration du bouton de localisation sur la carte"
                    ]
                },
                {
                    date: '2026-05-20',
                    title: "Update divers",
                    version: '2.58',
                    description: "Améliorations diverses pour admins et opérateurs",
                    items: [
                        "Ajoute la possibilité de configurer chaque alarme pour chaque balise en envoi à la télésurveillance",
                        "Admin SMS : message de feedback pour les modifications de champs impossibles",
                    ]
                },
                {
                    date: '2026-05-28',
                    title: "Amélioration corridorings / geofencings",
                    version: '2.59',
                    description: "Amélioration de l'utilisation des fonctionnalités dans les missions",
                    items: [
                        "Il est maintenant possible d'associer des geofencings à des corridorings pour élargir certaines zones de passage ou de contrôle",
                        "Amélioration de la gestion de geofencings et corridorings, on voit maintenant plus d'informations sur les cartes",
                        "L'historique des missions affiche maintenant par défaut le corridoring utilisé",
                        "Correction : l'historique des missions affiche maintenant des icônes d'évènements adaptés aux différentes alarmes",
                        "Correction : pour les opérateurs SMS, le changement de client change l'adresse de la page de façon plus logique"
                    ]
                },
                {
                    date: '2026-06-01',
                    title: "Export facturation",
                    version: '2.60',
                    description: "Ajoute l'export en PDF de la facturation pour le service SMS",
                    items: [
                        "Ajout de la fonction export de la facturation en PDF dans la partie facturation des administrateurs SMS",
                        "Amélioration des wordings sur la carte version mobile",
                    ]
                },
                {
                    date: '2026-06-23',
                    title: "Nouvelle balise sécurité",
                    version: '2.61',
                    description: "Gestion des nouvelles balises sécurité",
                    items: [
                        "Ajoute les nouvelles balises de sécurité ainsi que les commandes associées depuis la carte",
                    ]
                },
                {
                    date: '2026-06-25',
                    title: "Modifications d'interface",
                    version: '2.62',
                    description: "Améliorations d'interface divers",
                    items: [
                        "Modification de l'affichage pour la config des alarmes par balise (admins SMS)",
                        "Ajoute la colonne date de réception des messages (admins SMS)",
                        "Ajoute une scrollbar sur la carte pour les véhicules ayant beaucoup d'options"
                    ]
                },
                {
                    date: '2026-07-09',
                    title: "Amélioration de la navigation des alarmes",
                    version: '2.63',
                    description: "Améliorations d'interface divers",
                    items: [
                        "Ajoute la numérotation de pagination dans l'URL sur la page des évènements",
                        "Ajoute la possibilité de filtrer par type d'alarme",
                        "Ajoute l'heure dans le filtrage des dates",
                        "Correction de la pagination avec 30 résultats par page",
                        "Corrections diverses"
                    ]
                },
                {
                    date: '2026-07-13',
                    title: "Hotfix affichage",
                    version: '2.64',
                    description: "Correction de la page balise",
                    items: [
                        "L'affichage sur ordinateur ne déborde plus pour les noms trop longs"
                    ]
                },
                {
                    date: '2026-07-23',
                    title: "Goeocoding mondial",
                    version: '2.65',
                    description: "Ajoute le geocoding mondial",
                    items: [
                        "Les adresses seront maintenant résolues mondialement, dans tous les pays étant référencés",
                        "Sur la page de connexion, ajout d'un icône pour visualiser le mot de passe actuellement saisi",
                        "Modification de la page de connexion"
                    ]
                },
                {
                    date: '2026-07-30',
                    title: "Lien de partage",
                    version: '2.66',
                    description: "Ajoute le lien de partage des véhicules",
                    items: [
                        "Les admins SMS peuvent générer des liens temporaire et les gérer depuis la page véhicule",
                        "Correction : le niveau de réception GSM des nouvelles balises a été corrigé",
                    ]
                },
                {
                    date: '2026-07-30',
                    title: "Mise à jour générale",
                    version: '2.67',
                    description: "Corrections et améliorations diverses",
                    items: [
                        "Corrige l'affichage sur les applications mobiles",
                        "Réduit la taille du logo en versions ordinateur, mobile et dans les applications",
                        "Enlève l'affichage des commandes pour les utilisateurs niveau visiteur"
                    ]
                },
            ]
        }
    },
    methods: {

    }
}
</script>